const RL_SCA_FLAG_KEY = "BT_AM_SCA_SUCCEED";

export const getSingleClickFlag = () =>
  sessionStorage.getItem(RL_SCA_FLAG_KEY) === "true";

export const saveSingleClickFlag = (flag: boolean) =>
  sessionStorage.setItem(RL_SCA_FLAG_KEY, flag.toString());
export const deleteSingleClickFlag = () =>
  sessionStorage.removeItem(RL_SCA_FLAG_KEY);
